import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Skeleton } from "../components/ui/Skeleton";
import useAuthStore from "../stores/useAuthStore";
import OutLook from "./OutLook";

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const { isAuthenticated, checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="space-y-4 w-full max-w-md p-8">
          <Skeleton className="h-8 w-3/4" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <OutLook>{children}</OutLook>;
};

export default ProtectedRoute;
